import { motion } from 'framer-motion'
import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Container = styled(motion.span)`
  display: flex;
  align-items: center;
  gap: 0.4em;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.8em;
  margin: 3rem;
  cursor: pointer;
  font-size: 1.2em;
  background-color: rgba(255 255 255 / 85%);
  z-index: 1;

  ${mq.medium} {
    margin: 5rem;
  }

  a {
    svg {
      color: white;
      border-radius: 50%;
      background-color: var(--text-color);
    }
  }

  svg {
    display: block;
    width: 1.2em;
    overflow: visible;
  }
`

export const Toggle = styled(motion.button)`
  all: unset;
  cursor: pointer;
`
